module.exports = __webpack_public_path__ + "assets/b153512dd3b08137189e608058d8b1e5.png";